module.exports = __webpack_public_path__ + "static/media/fantasy_healer.41b2a719.png";